import * as React from "react"
import { LinkModule } from "@/components"
import t from "@/constants/wording"
import * as styles from "./index.module.scss"
import icon1 from "./product-advantage-icon-1.svg"

const ProductAdvantages: React.FC<{ isShowLookDetailLink?: boolean, myData?: ProductAdvantages[] }> = ({ isShowLookDetailLink = true, myData }) => {
  const data: ProductAdvantages[] = myData ?? []
  if (data[0]?.banner?.media?.url) {
    data[0].banner.media.url = icon1
  }
  return (
    <div className={styles.container}>
      {data.map(item => (
        <div className={styles.inner}>
          <div className={styles.logo}>
            {item.banner && (
              <img alt={item.banner.alt} src={item.banner.media.url} />
            )}
          </div>
          <div className={styles.content}>
            <h2>{item.title}</h2>
            <p className={styles.p1}>{item.description}</p>
            {isShowLookDetailLink && (
              <div className={styles.lookDetail}>
                <LinkModule to={`/product-advantages-detail/${item.id}`}>
                  {t("look detail")}
                </LinkModule>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ProductAdvantages
